import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Organization } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Organization>>>;

const getOrganizationsForCoach = (): ReturnType => {
    return Request.get('/organizations/coach');
};

export default getOrganizationsForCoach;
